import React, { Fragment } from 'react';
import { getHighlightedValue } from '../../../aml/sections/attributes/highlighters';

interface Props {
  highlight?: string;
  highlightColor?: string;
  type?: string;
  properties: any;
}

const Match = ({ highlight, highlightColor, type, properties }: Props) => {
  const displayPerson = (person: any) => {
    return (
      <React.Fragment>
        {person.birthDate && (
          <p>
            <span className={'property'}>Date Of Birth: </span>
            {person.birthDate.join(', ')}
          </p>
        )}
        {person['Resident of'] && (
          <p>
            <span className={'property'}>Residency: </span>
            {person['Resident of'].join(', ')}
          </p>
        )}
        {person.Citizenship && (
          <p>
            <span className={'property'}>Citizenship: </span>
            {person.Citizenship.join(', ')}
          </p>
        )}
      </React.Fragment>
    );
  };

  const displayEntity = (entity: any) => {
    return (
      <React.Fragment>
        {entity['Date of Registration'] && (
          <p>
            <span className={'property'}>Registration Date: </span>
            {entity['Date of Registration'][0]}
          </p>
        )}
        {entity['Country of Registration'] && (
          <p>
            <span className={'property'}>Country of Registration: </span>
            {entity['Country of Registration'].join(', ')}
          </p>
        )}
        {entity['Country of Affiliation'] && (
          <p>
            <span className={'property'}>Country of Affiliation: </span>
            {entity['Country of Affiliation'].join(', ')}
          </p>
        )}
      </React.Fragment>
    );
  };

  const displayUnknown = (unknown: any) => {
    return (
      <React.Fragment>
        {unknown.birthDate && (
          <p>
            <span className={'property'}>Date Of Birth: </span>
            {unknown.birthDate[0]}
          </p>
        )}
        {unknown.description && (
          <p>
            <span className={'property'}>Description: </span>
            {getHighlightedValue({ text: unknown.description.join(', ') })}
          </p>
        )}
      </React.Fragment>
    );
  };

  const renderBasedOnType = (type: string | undefined) => {
    switch (type) {
      case 'PERSON':
        return displayPerson(properties);
      case 'ENTITY':
        return displayEntity(properties);
      default:
        return displayUnknown(properties);
    }
  };
  return (
    <Fragment>
      {type ? (
        <p>
          <b className={'match-type'}>{type.toLowerCase()}:</b>
        </p>
      ) : (
        <p>
          <b className={'match-type'}>Details:</b>
        </p>
      )}
      {properties.name && (
        <p>
          <span className={'property'}>Primary Name: </span>
          {getHighlightedValue({ text: properties.name[0], highlight, color: highlightColor })}
        </p>
      )}

      {properties.aliases && (
        <p>
          <span className={'property'}>Also Known As: </span>
          {getHighlightedValue({ text: properties.aliases.join(', '), highlight, color: highlightColor })}
        </p>
      )}

      {renderBasedOnType(type)}
    </Fragment>
  );
};

export default Match;
